import { render } from "./AddBtn.vue?vue&type=template&id=20d543ef"
import script from "./AddBtn.vue?vue&type=script&lang=js"
export * from "./AddBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__